import {
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
} from '@mui/material';
import { deleteSession, userSessionActions, userSessionState } from '../../slices/userSessionSlice';
import { filterMenuFontStyle, listFontStyle } from '../../content/shared/CommonFontSize';
import { useDispatch, useSelector } from 'react-redux';

import ActionButton from '../ActionButton.js/index.js';
import React from 'react';
import { SessionTimeOut } from '../../appsettings';
import { loginLink } from 'src/router/routerLink';
import useAuth from '../../hooks/useAuth';
import { useNavigate } from 'react-router-dom';
import log from 'loglevel';

const UserSessionDialog = () => {
    const { logout } = useAuth();
    const { open, msgType } = useSelector(userSessionState);
    const navigate = useNavigate();
    const dispatch = useDispatch();
    open && setTimeout(() => {
        msgType == 'Expire' || null ? handleExpireLogout() : handleLogout();
    }, SessionTimeOut);

    const handleClose = () => {
        dispatch(userSessionActions.openDialog({
            open: false,
            msgType: null
        }))
    }
    const handleExpireLogout = async () => {
        sessionStorage.removeItem("SettingProfile");
        await logout();
        navigate(loginLink);
        handleClose();
    }
    const handleLogout = async () => {
        log.info("debug deleteSession")
        dispatch(deleteSession())
            .unwrap()
            .then(async () => {
                sessionStorage.removeItem("SettingProfile");
                await logout();
                navigate(loginLink);
                handleClose();
            })
            .catch(() => {
                sessionStorage.removeItem("SettingProfile");
                navigate(loginLink);
                handleClose();
            });

    }

    return (
        <>
            <Dialog
                open={open}
                onClose={(_, reason) => {
                    if (reason !== "backdropClick") {
                        handleClose();
                    }
                }}
                sx={{ backdropFilter: "blur(5px)", }}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                PaperProps={{ style: { width: '350px', height: '150px', borderRadius: '2px', backgroundColor: '#2C314C', } }}
            >
                <DialogTitle
                    id="alert-dialog-title"
                    sx={{ ...listFontStyle, color: "#E6E7EB", fontWeight: "700", top: '16px', left: '16px' }}
                >
                    {msgType == 'Expire' ? 'Multiple Login Detected' : 'Session Terminated'}
                </DialogTitle>
                <DialogContent sx={{ overflowY: 'hidden' }}>
                    <DialogContentText
                        id="alert-dialog-description"
                        sx={{ ...filterMenuFontStyle, fontWeight: "400", letterSpacing: '0.32px' }}
                    >
                        {msgType == 'Unauthorized' && 'Your session has been terminated.You will have to log in to start a new session.'}
                        {msgType == 'Expire' && 'Another login has been detected from different browser. You will have to log in to start a new session.'}
                        {msgType == 'Locked' && "Your session has been terminated. Your account has been locked by an administrator. Please contact your administrator."}
                        {msgType == 'Deleted' && "Your session has been terminated. Your account has been deleted by an administrator. Please contact your administrator."}
                        {msgType == 'ForceLogout' && "Your session has been terminated. You have exceeded the 24 hour per session limit, please log in again to continue using CVX."}
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <ActionButton
                        handleClick={msgType == 'Expire' || null ? handleExpireLogout : handleLogout}
                        label='Okay'
                        buttonStyle={{ width: '80px', right: '16px' }}
                    />
                </DialogActions>
            </Dialog>
        </>
    )
}
export default UserSessionDialog;